import { StreamVideoClient } from '@stream-io/video-react-sdk';
import { nanoid } from 'nanoid';
import { APIUtils } from '../../utils/apiutils';
import httpClient from '../../services/http';
import { CUSTOM_EVENTS } from '../../utils/constants';

export class GetStreamHandler {
    static instance = null;
    constructor() {
        if (GetStreamHandler.instance) {
            return GetStreamHandler.instance;
        }
        this.client = null;
        this.myGetstreamID = null;
        this.unsubEvents = null;
        GetStreamHandler.instance = this;
        return this;
    }

    async getClient({userId, name}) {
        const apiKey = process.env.REACT_APP_GETSTREAM_API_KEY;

        const myID = `${name}_${userId}`;
        const user = {
            id: myID,
            name,
            image: `https://getstream.io/random_svg/?id=${userId}&name=${name}`,
        };

        const { err, res } = await httpClient.post(APIUtils.getAPIEndpoint('user:getstream-token'), {userId: `${name}_${userId}`})
        .then(res => ({ err: null, res: res.data }))
        .catch(err => ({ err, res: null }));

        // console.log({err, res});
        if (err) {
            return { err, client: null };
        }

        const token = res.token;
        if (!this.client) {
            this.client = new StreamVideoClient({ apiKey, user, token });
        }

        this.myGetstreamID = myID;
        this.subscribeToEvents();
        return { err: null, client: this.client };
    }

    getMyID() {
        return this.myGetstreamID;
    }

    // startCall() {
    //     const callId = `${new Date().getTime()}_getstream_callid`;
    //     const call = this.client.call('default', callId);
    //     call.join({ create: true });
    //     console.log({call})
    //     // const callLink = `http://localhost:5173/join?call_id=${callId}&call_type=default`
    //     console.log(`http://localhost:5173/join?call_id=${callId}&call_type=default`)

    //     return call
    // }

    // async joinCall({callType, callId}) {
    //     const call = this.client.call(callType, callId);
    //     await call.join();
    //     console.log('Call joined')
    //     return call
    // }

    async ringCall({mineId, userIds}) {
        const members = userIds.map(id => ({ user_id: id }));
        members.push({user_id: mineId});

        const callID = nanoid();
        // const call = this.client.call('treatu_default', callID);
        const call = this.client.call('default', callID);
        await call.getOrCreate({
            ring: true,
            data: {
                created_by_id: mineId,
                members
            },
        });

        return call;
    }

    subscribeToEvents() {
        // Subscribe to all events
        this.unsubEvents = this.client.on('all', (event) => {
            // console.log({event});

            if (event) {
                document.dispatchEvent(new CustomEvent(CUSTOM_EVENTS.MONITOR_GS_EVENTS, {detail: {event}}));
            }
        });
    }

    destroy() {
        // Clean up resources
        this.client = null;
        this.myGetstreamID = null;
        GetStreamHandler.instance = null;
        if (this.unsubEvents) {
            this.unsubEvents();
        }
    }
}

// export const getStreamHandler = new GetStreamHandler()